// extracted by css-extract-rspack-plugin
module.exports =  {"titleRow":"PromoteToOwnerDialog-m__titleRow___ZmdfD"};